import {WebcamGenqlSelection} from "@/gql/gen";

export const WebcamFields: WebcamGenqlSelection = {
    ID: true,
    NAME: true,
    PROPERTIES: {
        CODE: true,
    }
}
